<div class="video-player">
  <video
    #target
    class="video-player__media"
    muted
    playsinline
    crossorigin="anonymous"
    preload="auto"
    (touchstart)="onVideoTouch($event)"
  ></video>
  <button
    *ngIf="sessionOptions?.eventStatus === EventStatusEnum.LIVE"
    type="button"
    class="btn video-player__live-badge"
    [class.video-player__live-badge--live]="isAtLiveEdge"
    (click)="jumpToLive()"
    title="Ir para ao vivo"
  >
    <i class="fa-sharp fa-solid fa-circle" aria-hidden="true"></i>
    <span class="video-player__live-text">Live</span>
  </button>
  <div
    class="video-player__controls"
    *ngIf="sessionOptions"
    (click)="$event.stopPropagation()"
  >
    <div class="video-player__controls-top">
      <div
        class="video-player__controls-center"
        *ngIf="sessionOptions?.eventStatus === EventStatusEnum.LIVE"
      >
        <div class="video-player__progress" *ngIf="!isAtLiveEdge">
          <div
            class="video-player__progress-bar"
            [style.width.%]="liveProgressPercent"
          ></div>
        </div>
      </div>
    </div>

    <div class="video-player__controls-bottom">
      <div class="video-player__controls-left">
        <button
          type="button"
          class="btn btn--primary btn--no-bg"
          (click)="togglePlayPause()"
          title="Play/Pause"
        >
          @if (isPlaying) {
          <i class="fa-sharp fa-solid fa-pause" aria-hidden="true"></i>
          } @else {
          <i class="fa-sharp fa-solid fa-play"></i>
          }
        </button>
        <ng-container *ngIf="hasHls">
          <div
            class="custom-select custom-select--sm video-player__quality-select"
          >
            <div
              class="custom-select__trigger"
              (click)="toggleQualityDropdown()"
            >
              <span class="custom-select__value">{{
                getSelectedQualityLabel()
              }}</span>
              <i
                class="custom-select__arrow fa-sharp fa-solid fa-chevron-down"
                [class.custom-select__arrow--rotated]="isQualityDropdownOpen"
              ></i>
            </div>
            <div
              class="custom-select__panel"
              [class.custom-select__panel--open]="isQualityDropdownOpen"
            >
              <div
                class="custom-select__option"
                [class.custom-select__option--selected]="
                  selectedQuality === 'auto'
                "
                (click)="selectQuality('auto')"
              >
                Auto
              </div>
              <div
                class="custom-select__option"
                *ngFor="let l of levels; let i = index"
                [class.custom-select__option--selected]="selectedQuality === i"
                (click)="selectQuality(i)"
              >
                {{ l.height ? l.height + 'p' : l.name || 'Level ' + i }}
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="video-player__controls-right">
        <div class="video-player__volume-button">
          <button
            type="button"
            class="btn btn--primary btn--no-bg"
            (click)="toggleMute()"
            title="Mute/Unmute"
          >
            @if(muted) {
            <i class="fa-sharp fa-solid fa-volume-slash"></i>
            }@else {
            <i class="fa-sharp fa-solid fa-volume"></i>
            }
          </button>
          <input
            type="range"
            min="0"
            max="1"
            step="0.05"
            class="video-player__volume-slider"
            [value]="volume"
            (input)="setVolume($event)"
          />
        </div>
        <button
          type="button"
          class="btn btn--primary btn--no-bg"
          (click)="toggleFullscreen()"
          title="Full screen"
        >
          @if(!isFullscreen) {
          <i class="fa-sharp fa-solid fa-expand" aria-hidden="true"></i>
          }@else {
          <i class="fa-sharp fa-solid fa-compress" aria-hidden="true"></i>
          }
        </button>
      </div>
    </div>
  </div>
</div>
